var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-modal",on:{"click":function($event){return _vm.$emit('close')}}},[_c('div',{staticClass:"app-modal__inner",style:({ maxWidth: `${_vm.dialogMaxWidth}px` }),on:{"click":function($event){$event.stopPropagation();}}},[_c('AppModalContainer',{staticClass:"app-modal__body"},[_vm._t("default")],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }